export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      location: {
        locationId: 1,
        locationUuid: "locations001",
        deviceSerial: "XJDUERYC896CJS",
        modelNumber: "JS01H",
        modelName: "XXXXBOX",
        activatedAt: 1594880785395,
        disabledAt: null,
        status: 1,
        profiles: [
          {
            profileOrder: 1,
            body: "profiles1",
          },
          {
            profileOrder: 3,
            body: "profiles3",
          },
          {
            profileOrder: 2,
            body: "profiles2",
          }
        ],
        attributeInfo: [
          {
            attributeTypeName: "属性タイプA",
            attributeGroupName: "属性グループA"  
          },
          {
            attributeTypeName: "属性タイプB",
            attributeGroupName: "属性グループA"  
          }
        ],
        note: "note"
      }
    }
  }
}